import { Grid, Filter, Page, Sort, Edit, Toolbar as GridToolbar } from '@syncfusion/ej2-grids';
import { DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { DateHelper } from '../../Helpers/DateHelper';
import { ModalHelper } from '../../Helpers/ModalHelper';
import { PdfViewer, Toolbar, Magnification, Navigation, LinkAnnotation} from '@syncfusion/ej2-pdfviewer';
import { InboxStatus } from '../../Models/MailboxPdf/InboxStatus';
import { SyncfusionDropdownHelper } from '../../Helpers/SyncfusionDropdownHelper';
import { SyncfusionGridHelper } from '../../Helpers/SyncfusionGridHelper';

export class ImportInboxManager {

    constructor(private containerElement: JQuery) { }

    private importInboxGrid : Grid;   
    private importEmailItemPopup : ModalHelper; 

    public initialize() {
        var self = this;

        Grid.Inject(Edit, GridToolbar, Filter, Page, Sort);
        PdfViewer.Inject(Toolbar, Magnification, Navigation, LinkAnnotation);

        self.initializeEmailsTable();
    }

    private initializeEmailsTable() {
        var self = this;

        var loadingContainer = self.containerElement.find('#loading-container');
        var emailsTableContainer = self.containerElement.find('#email-inbox-data-container');

        var emailsGridElement : JQuery<HTMLElement> = self.containerElement.find('#ImportInboxGrid');
        var emailsContentElement : JQuery<HTMLElement> = emailsGridElement;

        this.importEmailItemPopup = new ModalHelper();
        this.importEmailItemPopup.createModal("email-details-popup", true);

        var creationDateElem;
        var creationDateObj;

        let erpData: DataManager = new DataManager({
            url: '/api/company/import/emails',
            adaptor: new WebApiAdaptor
        });

        self.importInboxGrid = new Grid(
        {
            height: '100%',
            dataSource: erpData,
            toolbarTemplate: '#toolbar-template',
            editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, mode: 'Normal', newRowPosition: 'Top' },
            columns: [
                { field: 'Id', isPrimaryKey: true, visible: false, allowEditing: false, validationRules: { required: true }},  
                { field: 'CreationDateTimeString', headerText: 'Received date', autoFit: true, allowEditing: false, allowFiltering: true,
                    filterBarTemplate: {
                        create: () => { 
                            creationDateElem = document.createElement('input'); 
                            return creationDateElem; 
                        }, 
                        write: (args) => {
                            const persistedValue =
                                args?.value
                                ?? self.importInboxGrid?.filterSettings?.columns
                                    ?.find((x: any) => x.field === 'CreationDateTimeString')
                                    ?.value;

                            creationDateObj = new DatePicker({
                                value: SyncfusionGridHelper.parseDatePickerValue(persistedValue),
                                format: 'dd-MM-yyyy',
                                floatLabelType: 'Never',

                                change: (args) => {
                                    const dateValue = DateHelper.DateToString(args.value);

                                    if (dateValue == undefined) {
                                        self.importInboxGrid.removeFilteredColsByField(
                                            'CreationDateTimeString'
                                        );
                                    } else {
                                        self.importInboxGrid.filterByColumn(
                                            'CreationDateTimeString',
                                            'equal',
                                            dateValue,
                                            undefined,
                                            true
                                        );
                                    }
                                }
                            });

                            creationDateObj.appendTo(creationDateElem);
                        } 
                    }, width: '150px', validationRules: { required: true }},
                { field: 'Status', headerText: 'Status', autoFit: true, validationRules: { required: false }, allowSorting: false, allowFiltering: true, width: '175px', filterBarTemplate: SyncfusionDropdownHelper.templateEnumOptionsDropDown(() => self.importInboxGrid, 'Status', Object.keys(InboxStatus).filter(key => isNaN(Number(key))), 
                    (args) => {
                    if (args.value !== 'All') {
                        self.importInboxGrid.filterByColumn(args.item.parentElement.id.replace('_options', ''), 'equal', args.value, undefined, true);
                    } else {
                        self.importInboxGrid.removeFilteredColsByField(args.item.parentElement.id.replace('_options', ''));
                    }
                }, 'ReadyToValidate')},
                { field: 'Priority', headerText: 'Priority', autoFit: true, validationRules: { required: false }, allowSorting: false, allowFiltering: false, width: '100px',},
                { field: 'Attachments',  headerTemplate: '<i title="Attachments" class="fa-solid fa-paperclip"></i>', toolTip: "Attachments", autoFit: true, validationRules: { required: false }, 
                    allowSorting: false, allowFiltering: false, textAlign: 'Center', width: '30px',},
                { field: 'Sender', headerText: 'Sender', autoFit: true, validationRules: { required: false }, allowSorting: false, allowFiltering: true, width: '350px',},
                { field: 'Subject', headerText: 'Subject', autoFit: true, validationRules: { required: false }, allowSorting: false, allowFiltering: true},
            ],
            allowSorting: true,
            allowPaging: true,
            allowFiltering: true,
            allowSelection: false,
            enablePersistence: true,
            pageSettings: { pageSize: 100 },
            filterSettings:{
                columns: [
                    { field: 'Status', value: 'ReadyToValidate', operator: 'equal' }
                ],
            },
            created: () => {
                emailsContentElement = emailsContentElement.find('.e-content')

                loadingContainer.addClass('d-none');
                emailsTableContainer.removeClass('d-none');

            },
            recordClick: (e) => {
                self.importEmailItemPopup.load(`?emailId=${e.rowData.Id}&handler=EmailItemDetails`, undefined, () => {
                    self.bindEmailImportContainer();
                });
                return;
            }
        });

        self.importInboxGrid.appendTo('#ImportInboxGrid');

        var toolbar = this.containerElement.find('#toolbar-template');
        if(toolbar != undefined && toolbar.length > 0) {
            var clearFiltersButton = toolbar.find('#clear-filters-button');
            clearFiltersButton.off('click').on('click', () => {
                self.importInboxGrid.pageSettings.currentPage = 1;
                self.importInboxGrid.clearFiltering();
                self.importInboxGrid.refreshHeader();
            })
        }
    }

    private bindEmailImportContainer() {
        var self = this;
        var emailDetailsContainer = self.importEmailItemPopup.getModalContainer();

        var pdfViewerContainer = emailDetailsContainer.find('#pdf-viewer');
        var spinner = emailDetailsContainer.find('#pdf-spinner');

        let pdfViewer: PdfViewer = new PdfViewer({
            documentPath: pdfViewerContainer.data('path'),
            enableNavigationToolbar: false,
            enableStickyNotesAnnotation: false,
            enableThumbnail: false,
            enableBookmark: false,
            enableHyperlink: true,
            enableAnnotationToolbar: false,
            enableDownload: false,
            toolbarSettings: {
                showTooltip: false,
                toolbarItems: ['PageNavigationTool', 'MagnificationTool']
            },
            height: '99%',
            created: () => {
                spinner.remove();
            },
            documentLoad: (args) => {
                var formFields = pdfViewer.retrieveFormFields();
                formFields.map((formField) => {
                    var isReadOnly : any = { isReadOnly: true };
                    pdfViewer.formDesignerModule.updateFormField(formField, isReadOnly);
                });
            }
        });

        pdfViewer.appendTo('#pdf-viewer');
    }
}